document.addEventListener('DOMContentLoaded', () => {
  const buildCss = () => {
    const rootStyles = getComputedStyle(document.documentElement);
    const heading = rootStyles.getPropertyValue('--heading-color').trim() || '85, 70, 63';
    const brand = rootStyles.getPropertyValue('--brand-color').trim() || '95, 125, 83';
    const headFont = rootStyles.getPropertyValue('--font-heading-family').trim() || 'sans-serif';
    const bodyFont = rootStyles.getPropertyValue('--font-body-family').trim() || 'sans-serif';

    let fontFaces = '';
    for (const sheet of document.styleSheets) {
      try {
        for (const rule of sheet.cssRules) {
          if (rule instanceof CSSFontFaceRule) fontFaces += rule.cssText + '\n';
        }
      } catch (error) {
        continue;
      }
    }

    return `${fontFaces}
body.product-page { font-family: ${bodyFont}; color: rgb(${heading}); padding-left: 0 !important; padding-right: 0 !important; }

.header-container .scm-rating { display: flex !important; flex-wrap: wrap !important; align-items: flex-start !important; column-gap: 56px; }
.header-container .left-header { width: 100% !important; max-width: 100% !important; flex: 0 0 100% !important; }
.header-container .right-header:not(:has(.buttons-container)) { display: none !important; }
.header-container .scm-rating p.title { display: block !important; flex: 0 0 100%; width: 100%; margin: 0 0 20px !important; font-size: 0; line-height: 0; }
.header-container .scm-rating p.title::before { content: 'Ratings & Reviews'; display: block; font-family: ${headFont}; font-size: 22px; line-height: 30px; font-weight: 700; color: rgb(${heading}); }

.header-container .scmRating1 { display: block !important; text-align: left !important; margin: 0 !important; float: none !important; }
.header-container .scmRating1 .info { display: flex !important; flex-direction: column !important; align-items: flex-start !important; width: auto !important; margin: 0 !important; text-align: left !important; }
.header-container .scmRating1 .info .number, .header-container .scmRating1 .info .number span { width: auto !important; font-family: ${headFont}; font-size: 46px; line-height: 1.1; font-weight: 700; color: rgb(${brand}); text-align: left !important; }
.header-container .scmRating1 .block-star-avenge { justify-content: flex-start !important; margin: 6px 0 !important; }
.header-container .scmRating1 .block-star-avenge svg path { fill: rgb(${heading}) !important; }
.header-container .scmRating1 .info .text-number, .header-container .scmRating1 .info .text-number span { width: auto !important; margin: 0 !important; font-size: 14px; color: rgba(${heading}, 0.7); text-align: left !important; }
.header-container .scmRating1 .info .text-number span:first-child { margin-right: 5px !important; }
.header-container .scmRating1 .info .buttons-container { margin-top: 16px; }
.header-container .scmRating2 { margin: 0 !important; float: none !important; }

.item-progress-bar .text-number span { font-size: 14px; font-weight: 600; color: rgb(${heading}); }
.item-progress-bar svg path { fill: rgb(${heading}) !important; }
.item-progress-bar .progress-bar { background: #f6ecdd !important; border-radius: 999px; }
.item-progress-bar .progress-bar > div { background: rgb(${brand}) !important; border-radius: 999px; }
.item-progress-bar .total-number { color: rgba(${heading}, 0.7); font-size: 14px; }
.item-progress-bar.noRating .text-number span, .item-progress-bar.noRating .total-number { color: rgba(${heading}, 0.45); }
.item-progress-bar.noRating svg path { fill: rgba(${heading}, 0.45) !important; }

body { --writeReviewBtnColor: rgb(${brand}); --writeReviewBtnTextColor: #fff; --submitBtnColor: rgb(${brand}); --submitBtnTextColor: #fff; }
button.write-review-button, .scm-btn-load-more, .scm-btn-submit { background: rgb(${brand}) !important; border: 0 !important; border-radius: 999px !important; height: auto !important; padding: 12px 26px !important; color: #fff !important; font-family: ${bodyFont} !important; font-size: 14px !important; font-weight: 700 !important; line-height: 1.2 !important; }
button.write-review-button:hover, .scm-btn-load-more:hover, .scm-btn-submit:hover { opacity: 0.9; box-shadow: none !important; }
.scm-pagination-load-more.visible { margin-bottom: 0; }
.scm-sort .scm-sort-title .title-text { color: rgb(${heading}); font-weight: 600; }

body > .grid > .scm-row { position: static !important; height: auto !important; display: flex !important; flex-wrap: wrap !important; gap: 16px; margin: 0 !important; padding: 0 !important; }
body > .grid > .scm-row > .item { position: static !important; top: auto !important; left: auto !important; transform: none !important; transition: none !important; width: calc(50% - 8px) !important; box-sizing: border-box !important; margin: 0 !important; padding: 0 !important; display: flex !important; }
body > .grid > .scm-row > .item .group-content { width: 100%; }
.grid .scm-row .item .group-content { background: #fdf3e7; border-radius: 16px; box-shadow: none; display: flex; flex-direction: column; overflow: hidden; }
.grid .scm-row .item .container-stars { order: 0; padding: 18px 20px 0; text-align: left; }
.grid .scm-row .item .container-stars .group-star { position: static; top: 0; background: transparent; padding: 0; border-radius: 0; display: flex; justify-content: flex-start; gap: 2px; }
.grid .scm-row .item .container-stars .group-star svg path { fill: #f0a13a !important; }
.grid .scm-row .item .container-stars .group-star svg.svg_none path { fill: rgba(${heading}, 0.15) !important; }
.grid .scm-row .item .content { order: 1; padding: 10px 20px 4px; font-size: 15px; line-height: 1.6; color: rgba(${heading}, 0.85); text-align: left; }
.grid .scm-row .item .content-full::before, .grid .scm-row .item .content-read-more::before { content: '\\201C'; }
.grid .scm-row .item .content-full::after, .grid .scm-row .item .content-read-more::after { content: '\\201D'; }
.grid .scm-row .item .info-author { order: 2; display: flex; align-items: center; gap: 12px; margin: auto 0 0; padding: 12px 20px 20px; }
.grid .scm-row .item .container-avatar .avatar-text { background: rgb(${brand}) !important; color: #fff !important; font-weight: 700; }
.grid .scm-row .item .flag-wrapper { display: none !important; }
.grid .scm-row .item .container-date-hel { display: none !important; }
.grid .scm-row .item .container-name { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; }
.grid .scm-row .item .container-name .name { font-family: ${headFont}; font-size: 16px; line-height: 1.2; font-weight: 700; color: rgb(${heading}); }
.grid .scm-row .item .container-name::after { content: 'Verified Buyer'; text-transform: uppercase; font-size: 11px; font-weight: 700; letter-spacing: 0.06em; color: rgba(${heading}, 0.6); }

.scm-write-review h2 { font-family: ${headFont}; color: rgb(${heading}); }
.scm-write-review form button, .scm-write-review form input[type='submit'] { background: rgb(${brand}) !important; border: 0 !important; border-radius: 999px !important; color: #fff !important; font-weight: 700 !important; padding: 12px 26px !important; }

@media screen and (min-width: 750px) {
  body > .grid > .scm-row { gap: 24px; }
  body > .grid > .scm-row > .item { width: calc(33.333% - 16px) !important; }
}
`;
  };

  const applyStyles = () => {
    const iframe = document.querySelector('.scm-reviews-importer-iframe.main-widget-product');
    if (!iframe) return;
    let doc;
    try {
      doc = iframe.contentDocument;
    } catch (error) {
      return;
    }
    if (!doc || !doc.head || !doc.querySelector('.header-container')) return;

    const buttons = doc.querySelector('.right-header .buttons-container');
    const summary = doc.querySelector('.scmRating1 .info');
    if (buttons && summary && !summary.contains(buttons)) summary.appendChild(buttons);

    if (!doc.getElementById('product-reviews-restyle')) {
      const styleTag = doc.createElement('style');
      styleTag.id = 'product-reviews-restyle';
      styleTag.textContent = buildCss();
      doc.head.appendChild(styleTag);
      iframe.contentWindow.dispatchEvent(new Event('resize'));
    }
  };

  applyStyles();
  setInterval(applyStyles, 800);
});
